import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Compiler, Component, ComponentFactory, ComponentRef, ModuleWithComponentFactories, NgModule, OnInit, ViewChild, ViewContainerRef
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LazyLoadScriptService } from '../../lazy_load_script_service';
import { PageService } from '../../services';
import { Meta, Title } from '@angular/platform-browser';

declare function OneHr();
@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss']
})
// @NgModule({
//   imports: [
//     CommonModule
//   ]
// })
export class ResourcesComponent implements OnInit {

  @ViewChild('container', { static: true, read: ViewContainerRef }) container: ViewContainerRef;

  private componentRef: ComponentRef<{}>;
  constructor(
    private service: PageService,
    public sanitizer: DomSanitizer,
    private compiler: Compiler,
    public cdRef: ChangeDetectorRef,
    private meta: Meta,
    private title: Title,
    private lazyLoadService: LazyLoadScriptService
  ) {
    this.meta.addTags([
      { name: 'description', content: 'Resources page of UN - One HR - Salary Survey' },
      { name: 'author', content: 'One HR, Salary Survey' },
      { name: 'keyword', content: 'One HR, Salary Survey, Resources' }
    ]);
    this.setTitle('UN - Resources');
  }
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  slug = 'resources';
  resourcesDocsList;
  resourcesList;
  lst = [];
  template: string;
  methodology: string;
  public ngOnInit() {

    this.service.get(this.slug).subscribe((response: any) => {
      var str = response.data.html?.map(ele => ele.html).join("");
      // this.template = str;
      // this.methodology = `
      //   <div class="col-md-6" *ngIf="resourcesList.length > 0" style="margin-bottom: 30px;">
      //     <div class="btn-group dropup col-md-12" ngbDropdown *ngFor="let resources of resourcesList">
      //       <button type="button" class="btn btn-secondary dropbtn dropdown-toggle"
      //       data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      //         {{resources.name}}
      //       </button>
      //       <div class="dropdown-menu dropdown-content rounded-0" *ngIf = "resourcesDocsList.length > 0">
      //         <!-- Dropdown menu links -->
      //         <div *ngFor="let resourcesDoc of resourcesDocsList">
      //           <div ngbDropdownItem class="custom-dropdownItem text-center padding-15"
      //             *ngIf="resourcesDoc.resourcesId._id==resources._id">
      //             <a target="_blank" href="{{resourcesDoc.filePath}}">{{resourcesDoc.displayName}}</a>
      //           </div>
      //         </div>
      //       </div>
      //     </div>
      //   </div>`;
      
      // this.template = `
      // <div class="sub-banner-new">
      //   <div class="align-centr-heading">
      //     <h1 class="heading-1 white biger" style="width:80%">Resources
      //     </h1>
      //   </div>
      // </div>

      // <div class="section">
      //   <div class="container-fluid">
      //     <div class="row">
      //       <div class="col-md-7">
      //         <p>The establishment of the salaries and allowances for locally recruited staff members
      //           through local salary surveys is a complex technical exercise in which a number of
      //           different parties are involved.
      //         </p>
      //         <p>
      //           The methodology is established by the International Civil Service Commission (ICSC),
      //           which is also responsible for conducting the surveys in the Headquarters duty stations
      //           (New York, Madrid, London, Montreal, Geneva, Rome, Vienna, Paris, and Kingston). For
      //           all other duty stations, the Chief Executives Board for Coordination has assigned the
      //           United Nations Secretariat the responsibility for conducting the surveys and promulgating
      //           the scales.
      //         </p>
      //         <p>
      //           In view of the difference in local labor markets, the ICSC has established a methodology
      //           applicable to the headquarters duty stations as well as duty stations that have a similar
      //           local labor market (Washington D.C., Bonn, Copenhagen, The Hague, Tokyo and
      //           Brussels) and a methodology applicable to all other duty stations. With respect to those
      //           other duty stations, this methodology further differentiates duty stations based on the
      //           local labor market, and the size of the UN locally recruited workforce.
      //         </p>
      //         <p>
      //           In conducting the surveys, the ICSC and the United Nations Secretariat work together
      //           with the local management team and the Local Salary Survey Committees (LSSCs) that
      //           are established in each duty station, which are composed of representatives from the
      //           administration and staff.
      //         </p>
      //         <p>
      //           In addition, with respect to the surveys conducted by the United Nations Secretariat, an
      //           advisory committee has been established – the Headquarters Salary Steering Committee,
      //           composed of staff members of the larger UN common system organizations and the ICSC
      //           Secretariat – which monitors whether the surveys have been conducted in accordance
      //           with the ICSC’s Methodology
      //         </p>
      //       </div>
      //       <div class="col-md-5">
      //         <img src="/media/salarySurvey/files-1632450915967.PNG" class="img-fluid w-100" alt="...">
      //       </div>
      //     </div>
      //   </div>
      // </div>
      // `;
      // str = str.replace('<div class="col-md-6">&#10;&#10;            </div>', `${this.methodology}`)
      this.template = str;
      this.compileTemplate();
    });
    this.fetchResourcesandDocs();
    //this.listAllGroups();
  }

  openDropItem() {
    // console.log(window.innerWidth);
  }


  compileTemplate() {
    let metadata = {
      selector: `runtime-component-sample`,
      template: this.template,
      changeDetection: ChangeDetectionStrategy.OnPush
    };

    let factory = this.createComponentFactorySync(this.compiler, metadata, null, this);

    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
    this.componentRef = this.container.createComponent(factory);
    this.lazyLoadService.loadScript('/assets/js/onehr.js').subscribe(_ => {

    });
  }


  private createComponentFactorySync(compiler: Compiler, metadata: Component, componentClass: any, THIS: any,): ComponentFactory<any> {
    const cmpClass = componentClass || class RuntimeComponent {

      selected = null;
      // slug = 'resources';
      // resourcesDocsList;
      // resourcesList;

      public ngOnInit() {
        // THIS.service.getResourcesList(this.slug).subscribe((response: any) => {
        //   if (response.data) {
        //     this.resourcesList = response.data.result;
        //   }
        //   THIS.service.getResourcesDocsList(this.slug).subscribe((response: any) => {
        //     if (response.data) {
        //       this.resourcesDocsList = response.data;
        //     }
        //   });
        // });
      }
    };
    const decoratedCmp = Component(metadata)(cmpClass);

    const decoratedNgModule = NgModule({ imports: [CommonModule], declarations: [decoratedCmp] })(cmpClass);

    const module: ModuleWithComponentFactories<any> = compiler.compileModuleAndAllComponentsSync(decoratedNgModule);
    return module.componentFactories.find(f => f.componentType === decoratedCmp);
  }

  fetchResourcesandDocs() {
    this.service.getResourcesList(this.slug).subscribe((response: any) => {
      //console.log('response.data', response.data);
      if (response.data) {
        this.resourcesList = response.data.result;
        // console.log("Prniting this.resourcesList ", this.resourcesList);
      }

      this.service.getResourcesDocsList(this.slug).subscribe((response: any) => {
        //console.log('response.data', response.data);
        if (response.data) {
          this.resourcesDocsList = response.data;
          //this.resourcesList = response.data.resourcesId;
        }
      });
    });
  }
}
